import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const initialUsers = [
  { id: 1, name: 'Momar Diop', email: 'momar@gmail.com', role: 'Admin', status: 'Actif' },
  { id: 2, name: 'Fatou Ndiaye', email: 'fatou@gmail.com', role: 'Utilisateur', status: 'Actif' },
  { id: 3, name: 'Ibrahima Sow', email: 'ibrahima@gmail.com', role: 'Utilisateur', status: 'Inactif' },
  { id: 4, name: 'Aminata Fall', email: 'aminata@gmail.com', role: 'Modérateur', status: 'Actif' },
];

const Users = () => {
  const [users, setUsers] = useState(initialUsers);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [newUser, setNewUser] = useState({ name: '', email: '', role: 'Utilisateur', status: 'Actif' });

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  const handleAdd = () => {
    if (!newUser.name || !newUser.email) return;
    setUsers([...users, { ...newUser, id: users.length + 1 }]);
    setNewUser({ name: '', email: '', role: 'Utilisateur', status: 'Actif' });
    setShowForm(false);
  };

  const handleDelete = (id) => {
    setUsers(users.filter(u => u.id !== id));
  };

  return (
    <div className="flex min-h-screen bg-gray-900">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-6">

          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-white text-xl font-bold">Gestion des utilisateurs</h2>
            <button
              onClick={() => setShowForm(!showForm)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition duration-200"
            >
              + Ajouter
            </button>
          </div>

          {/* Formulaire ajout */}
          {showForm && (
            <div className="bg-gray-800 rounded-xl p-4 mb-6 grid grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Nom complet"
                value={newUser.name}
                onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                className="bg-gray-700 text-white p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Email"
                value={newUser.email}
                onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                className="bg-gray-700 text-white p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={newUser.role}
                onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                className="bg-gray-700 text-white p-3 rounded-lg focus:outline-none"
              >
                <option>Utilisateur</option>
                <option>Modérateur</option>
                <option>Admin</option>
              </select>
              <button
                onClick={handleAdd}
                className="bg-green-600 hover:bg-green-700 text-white p-3 rounded-lg transition duration-200"
              >
                Confirmer
              </button>
            </div>
          )}

          {/* Recherche */}
          <input
            type="text"
            placeholder="Rechercher un utilisateur..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-gray-800 text-white p-3 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          {/* Table */}
          <div className="bg-gray-800 rounded-xl overflow-hidden">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="text-gray-400 text-left p-4">Nom</th>
                  <th className="text-gray-400 text-left p-4">Email</th>
                  <th className="text-gray-400 text-left p-4">Rôle</th>
                  <th className="text-gray-400 text-left p-4">Statut</th>
                  <th className="text-gray-400 text-left p-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((user) => (
                  <tr key={user.id} className="border-b border-gray-700 hover:bg-gray-700 transition duration-150">
                    <td className="text-white p-4">{user.name}</td>
                    <td className="text-gray-400 p-4">{user.email}</td>
                    <td className="text-gray-400 p-4">{user.role}</td>
                    <td className="p-4">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        user.status === 'Actif' ? 'bg-green-900 text-green-400' : 'bg-red-900 text-red-400'
                      }`}>
                        {user.status}
                      </span>
                    </td>
                    <td className="p-4">
                      <button
                        onClick={() => handleDelete(user.id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded-lg text-sm transition duration-200"
                      >
                        Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Users;